import { Presentation } from 'lucide-react';

export function SlideArchitectureV3Panel({ data }) {
  if (!data?.slides?.length) return null;

  const stats = data.slide_statistics || {};

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-3 text-xs text-slate-500">
        <span className="flex items-center gap-1">
          <Presentation className="w-3.5 h-3.5" />
          {data.total_slides} slides
        </span>
        {stats.slides_per_concept_avg != null ? (
          <span>{stats.slides_per_concept_avg} avg / concept</span>
        ) : null}
        {stats.recap_count > 0 ? <span>{stats.recap_count} recaps</span> : null}
      </div>
      <div className="space-y-2 max-h-[55vh] overflow-y-auto">
        {data.slides.map((slide) => (
          <div
            key={slide.slide_id}
            className="rounded-md border border-slate-700/50 bg-slate-900/30 px-3 py-2 text-xs"
          >
            <div className="flex items-start justify-between gap-2">
              <p className="text-slate-200 font-medium">
                {slide.sequence_order}. {slide.concept_name}
              </p>
              <span className="text-[10px] text-slate-600 shrink-0">{slide.slide_id}</span>
            </div>
            <p className="text-slate-500 mt-0.5">{slide.primary_objective}</p>
            <div className="flex flex-wrap gap-1 mt-1.5">
              {(slide.artifacts || []).map((a) => (
                <span
                  key={a}
                  className="px-1.5 py-0.5 rounded border border-sky-500/25 bg-sky-950/30 text-sky-200/90 text-[10px]"
                >
                  {a}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
